var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"44","height":"26","viewBox":"0 0 44 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('ellipse',{attrs:{"opacity":"0.9","cx":"22","cy":"13","rx":"22","ry":"13","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }